// import axios from "axios";
// import AppConfig from "./app-config";

// const postgpsAxiosInstance = axios.create({
//   baseURL: AppConfig.api_baseurl,
//   timeout: 10000, // Set a timeout limit for requests
//   headers: AppConfig.headers,
// });

// // Request interceptor
// postgpsAxiosInstance.interceptors.request.use(
//   (config) => {
//     // Add any custom logic before the request is sent
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Token"] = `${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     // Handle request error
//     return Promise.reject(error);
//   }
// );

// // Response interceptor
// postgpsAxiosInstance.interceptors.response.use(
//   (response) => {
//     // Any custom logic for handling successful responses
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // Example: Redirect to login if unauthorized
//       localStorage.clear();
//       // window.location.href = "/";
//       // window.location.reload();
//     }
//     return Promise.reject(error);
//   }
// );

// export default postgpsAxiosInstance;

import axios from "axios";
import toast from "react-hot-toast";
import { CommonToast } from "components";
import AppConfig from "./postgps-config";

const postgpsAxiosInstance = axios.create({
  baseURL: AppConfig.api_baseurl,
  timeout: 10000, // Set a timeout limit for requests
  headers: AppConfig.headers,
});

// Request interceptor
postgpsAxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Token"] = `${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request error
    toast.error("Request failed. Please try again.");
    // return Promise.reject(error);
  }
);

// postgpsAxiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response) {
//       const { status, data } = error.response;
//       const requestData = error.config?.data;
//       const message = data?.responseMessage || "An unexpected error occurred.";

//       switch (status) {
//         case 401:
//           localStorage.clear();
//           toast.error("Your session has expired.");
//           window.location.href = "/";
//           break;
//         case 403:
//           toast.error(
//             message || "Forbidden access. You don't have permission."
//           );
//           break;
//         case 404:
//           toast.error(message || "Resource not found.");
//           break;
//         case 500:
//           toast.error(
//             message || "Internal server error. Please try again later."
//           );
//           break;
//         default:
//           if (message == 'Unknown error code: none') {
//             toast.error(`This Eway bill number is not valid`);
//           } else {
//             toast.error(message);
//           }
//       }

//       return Promise.reject(error); // 🔥 This is important
//     } else if (error.request) {
//       CommonToast("No response from the server. Please check your connection.");
//       return Promise.reject(error);
//     } else {
//       toast.error("Request failed. Please try again.");
//       return Promise.reject(error);
//     }
//   }
// );

postgpsAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      const message = data?.responseMessage ? data?.responseMessage : (data?.error ? data?.error : "An unexpected error occurred.") ;
      const requestData = error.config?.data;

      switch (status) {
        case 401:
          localStorage.clear();
          toast.error("Your session has expired.");
          window.location.href = "/";
          break;

        case 403:
          data?.responseMessage ? toast.error(data?.responseMessage) : toast.error("Forbidden access. You don't have permission.");
          break;
        case 404:
          data?.responseMessage ? toast.error(data?.responseMessage) : (data?.error ? toast.error(data?.error) : toast.error("Resource not found."));
          break;
        case 500:
          data?.responseMessage ? toast.error(data?.responseMessage) : toast.error("Internal server error. Please try again later.");

          break;

        default:
          // 👇 Corrected default case handling
          try {
            const parsedData = typeof requestData === "string" ? JSON.parse(requestData) : requestData;

            if (message == 'Unknown error code: none') {
              toast.error(`This Eway bill number is not valid`);
            } else if (parsedData?.lr_freight?.length === 0) {
              // Do not show error toast when lr_freight is empty
            } else {
              CommonToast(message); // Show common toast for meaningful errors
            }
          } catch (e) {
            // Fallback in case parsing fails or config is malformed
            CommonToast(message);
          }
      }

      return Promise.reject(error); // 🔥 Required to allow catch blocks to run
    } else if (error.request) {
      CommonToast("No response from the server. Please check your connection.");
      return Promise.reject(error);
    } else {
      toast.error("Request failed. Please try again.");
      return Promise.reject(error);
    }
  }
);

export default postgpsAxiosInstance;

